<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="lg" :visible="modal.show" :data="model" scrollable
                   :title="model.uuid ? $t(`Update Charge`) : $t(`Create New Charge`)"
                   @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation" :ok-title="$t('Submit')" :is-loading="loading">

      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="name"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <input-widget :model="model" attribute="is_active" type="checkbox" :is-switch="true"/>
        </div>
        <div class="col-md-3">
          <input-widget :model="model" attribute="taxable" type="checkbox" :is-switch="true"/>
        </div>
        <div class="col-md-3">
          <input-widget :model="model" attribute="is_vat_inclusive" type="checkbox" :is-switch="true"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <currency-input-widget :model="model" attribute="amount" :disabled="amountDisabled"/>
        </div>
        <div class="col-md-4">
          <percentage-input-widget :model="model" attribute="rate" :disabled="rateDisabled"/>
        </div>
        <div class="col-md-4">
          <multiple-category-select-input-widget :model="model" attribute="category_uuids" :label="$t('Categories')"
                                                 :items="model.category_uuids" :options="{multiple: true} "
                                                 :onUnselect="onCategoriesUnselect"
          />
        </div>
      </div>

      <charge-extra-parameters-input-widget :extra_parameters_template="model.extra_parameters_template"
                                            :model="model.extra_parameters" input-class="col-md-4"/>

      <charge-tiers :model="model" enable-first-tier-removal/>

    </artisio-modal>
  </ValidationObserver>


</template>

<script>
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import Charge from "@/modules/setup/branch/tabs/charges/Charge.model";
  import {createNamespacedHelpers} from "vuex";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import MultipleCategorySelectInputWidget from "@/core/widgets/MultipleCategorySelectInputWidget";
  import ChargeTiers from "@/core/components/charge-tiers/ChargeTiers";
  import ChargeTier from "@/core/components/charge-tiers/ChargeTiers.model";
  import CurrencyInputWidget from "@/core/widgets/CurrencyInputWidget";
  import PercentageInputWidget from "@/core/widgets/PercentageInputWidget";
  import ChargeExtraParametersInputWidget from "@/core/widgets/ChargeExtraParametersInputWidget";
  import ExtraParameters from "@/modules/setup/branch/tabs/charges/ExtraParameters.model";

  const {mapState, mapActions} = createNamespacedHelpers('setup/branch');


  export default {
    name: "ChargeModal",
    components: {
      ChargeExtraParametersInputWidget,
      ArtisioModal,
      InputWidget,
      MultipleCategorySelectInputWidget,
      ChargeTiers,
      CurrencyInputWidget,
      PercentageInputWidget
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new Charge(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.chargesModal,
        editObject: state => state.chargesModal.object,
      }),
      rateDisabled() {
        return this.model && !!(this.model.amount)
      },
      amountDisabled() {
        return this.model && !!(this.model.rate)
      }
    },
    watch: {
      editObject() {
        if (this.editObject && (this.editObject.uuid || this.editObject.branch_uuid)) {
          this.model = new Charge(this.editObject);
        }
      }
    },
    methods: {
      ...mapActions(['showChargesModal', 'hideChargesModal', 'updateCharge']),
      onShow() {
        this.showConfirmation = true

        let tiersMap = []
        if (this.editObject && this.editObject.tiers) {
          tiersMap = this.editObject.tiers.map(data => new ChargeTier(data))
        }
        this.editObject.tiers = tiersMap

        this.editObject.extra_parameters = new ExtraParameters(this.editObject.extra_parameters)

        let category_uuids = []
        if (this.editObject && this.editObject.categories) {
          category_uuids = this.editObject.categories.map(category => category.uuid)
        }
        this.editObject.category_uuids = category_uuids

        this.model = new Charge(this.editObject)
      },
      onHidden() {
        this.model = new Charge();
        this.hideChargesModal();
      },
      async onSubmit() {
        let response;

        this.loading = true;
        if (this.model.uuid) {
          response = await this.updateCharge(this.model);
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideChargesModal();

          if (!this.model.uuid) {
            this.$toast('success', this.$t('Charge was successfully created'));
          } else {
            this.$toast('success', this.$t('Charge was successfully updated'));
          }
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else if (response.body.tiers) {
            let errorData = [];
            Object.keys(response.body.tiers).forEach(key => {
              errorData.push(response.body.tiers[key])
            });
            this.displayErrorList(errorData, "Validation Error")
          } else if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      displayErrorList(errorList, title) {
        const listItemsArr = [];
        errorList.forEach(err => (listItemsArr.push(this.$createElement('li', {}, err))));
        this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listItemsArr), title);
      },
      onCategoriesUnselect(unselected) {
        let indexToRemove = this.model.categories.findIndex((category) =>
          category.uuid === unselected.uuid
        );

        this.model.categories.splice(indexToRemove, 1)
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>
